export default __webpack_public_path__ + "static/media/mar-del-plata-thumbnail.5f86d242.jpg";